import { logger } from '@/common/log';
import { debounce } from '@/common/utils/debounce';
import { afterPv } from '@/common/utils/afterPv';
import { Comment } from './api';

// 商详页返回时引导加购弹窗曝光埋点
export const logAlertBackPopupVisible = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'ADD_TO_CART_POPUP',
        });
    });
};

// 商详页返回时引导加购弹窗取消按钮点击埋点
export const logAlertBackCancelClick = () => {
    logger.sendClick({ action: 'CANCEL_ADD_TO_CART_POPUP' });
};

export const logShowProductNotice = (time: any) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_NOTICE',
            params: {
                time,
            },
        });
    });
};

export const logClickShopIcon = ({ product_id, shop_id }) => {
    logger.sendClick({
        action: 'SHOP_BUTTON',
        params: {
            product_id,
            shop_id,
            entrance_type: '',
        },
    });
};

export const logClickBuyNow = (
    itemId,
    entranceType,
    type,
    specInfo = '',
    skuid = '',
    coupon_id = '',
    is_with_coupon = 0,
    installment_type: -1 | 0 | 1,
    is_shipping_coupon
) => {
    // type:跳转类型，0-唤起规格页，1-跳转确认订单页
    // spec_info:商品规格
    // produtc_id:商品item_id
    // sku_id:skuid
    const params =
        type === 1
            ? {
                  product_id: itemId,
                  entrance_type: entranceType,
                  type,
                  spec_info: specInfo,
                  sku_id: skuid,
                  coupon_id,
                  is_with_coupon,
                  installment_type,
                  is_shipping_coupon,
              }
            : { product_id: itemId, entrance_type: entranceType, type, coupon_id, is_with_coupon, installment_type, is_shipping_coupon };
    logger.sendClick({
        action: 'BUY_NOW',
        params,
    });
};

export const logClickSpecs = (itemId, entranceType) => {
    logger.sendClick({
        action: 'PRODUCT_SPECIFICATION',
        params: { product_id: itemId, entrance_type: entranceType },
    });
};

// 商品详情主页面-曝光-商品规格
export const logShowSpecs = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_SPECIFICATION',
            params: {},
        });
    });
};

// 商品详情主页面-曝光-金币
export const logShowKwaiGold = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'KWAI_GOALS_TAG',
            params: {},
        });
    });
};

export const logShowKwaiGoldDef = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'KWAI_GOALS_DEFINITION',
            params: {},
        });
    });
};

export const logClickKwaiGoldTip = () => {
    logger.sendClick({
        action: 'KWAI_GOALS_TAG',
        params: {},
    });
};

// 商品详情主页面-曝光-商品图片 image_type:图片类型，0-规格图，1-主图
export const logShowImgContiner = (index, imageLength) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_IMAGE',
            params: { image_type: index < imageLength ? 1 : 0 },
        });
    });
};

export const logShowImgFullScreenContiner = (index, imageLength) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_IMAGE_FULL_SCREEN',
            params: { image_type: index < imageLength ? 1 : 0 },
        });
    });
};

export const logClickImgContiner = ({ index, type, itemId, entranceType, isHalfWebView, image_type }) => {
    logger.sendClick({
        action: 'PRODUCT_IMAGE',
        params: { index: index, action_type: type, product_id: itemId, entrance_type: entranceType, page_type: isHalfWebView ? 0 : 1, image_type },
    });
};

export const logShowPageErrBar = num => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_STATUS_BAR',
            params: { status_type: num },
        });
    });
};

export const logShowPageErr = (Index, itemId, entranceType) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'BOTTOM_PIC',
            params: { index: Index, product_id: itemId, entrance_type: entranceType },
        });
    });
};

export const logClickGuarantee = (itemId, isHalfWebView) => {
    logger.sendClick({
        action: 'GUARANTEE_SERVICE',
        params: { product_id: itemId, page_type: isHalfWebView ? 0 : 1 }, // page_type: 0-半屏，1-全屏
    });
};

export const logShowGuarantee = (itemId, isHalfWebView) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'GUARANTEE_SERVICE',
            params: { product_id: itemId, page_type: isHalfWebView ? 0 : 1 }, // page_type: 0-半屏，1-全屏
        });
    });
};

// 用户看到的运费信息
export const logShowFreightInfo = expressFee => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'FREIGHT_INFO',
            params: {
                freight: expressFee,
            },
        });
    });
};

export const onShareVisible = (times: number, itemId, entranceType) => {
    if (times === 1) {
        afterPv.then(() => {
            logger.sendShow({
                action: 'SHARE',
                params: {
                    // 商品id
                    product_id: itemId,
                    // 入口来源，0-站内私信分享，1-站外分享
                    entrance_type: entranceType,
                },
            });
        });
    }
};

export type TCartMarketingParams = {
    is_price_reduction: string;
    is_seckill: string;
    is_coupon: string;
    is_free_shipping: string;
    red_point_num?: string;
};

// 购物车入口
export const onCartVisible = (red_point_num?: number, params?: TCartMarketingParams) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'CART_ENTER',
            params: {
                // 红点数量
                red_point_num: red_point_num ? `${red_point_num}` : red_point_num,
                ...params,
            },
        });
    });
};
// 购物车入口点击
export const logClickCartEnter = (red_point_num: number, params?: TCartMarketingParams) => {
    logger.sendClick({
        action: 'CART_ENTER',
        params: {
            // 红点数量
            red_point_num: red_point_num ? `${red_point_num}` : red_point_num,
            ...params,
        },
    });
};

// 商详右下角固定的购物车
export const onCartRightCornerVisible = (red_point_num: number, params: TCartMarketingParams) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'CART_ENTER_PENDANT',
            params: {
                // 红点数量
                red_point_num: red_point_num ? `${red_point_num}` : red_point_num,
                ...params,
            },
        });
    });
};

export const onCartRightCornerEnter = (red_point_num: number, params: TCartMarketingParams) => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'CART_ENTER_PENDANT',
            params: {
                // 红点数量
                red_point_num: red_point_num ? `${red_point_num}` : red_point_num,
                ...params,
            },
        });
    });
};

// 添加购物车按钮
export const onAddCartVisible = () => {
    console.log('ADD_TO_CART');
    afterPv.then(() => {
        logger.sendShow({
            action: 'ADD_TO_CART',
        });
    });
};

// 添加购物车按钮（商详页返回时引导加购弹窗）
export const logAlertBackAddCartVisible = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'ADD_TO_CART',
            params: {
                type: 'popup',
            },
        });
    });
};

// 添加购物车按钮 (规格弹窗内)
export const onSpecAddCartVisible = ({ type = '', source = 'current', releated_item_id = '' }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'SPEC_ADD_TO_CART',
            params: { type, source, releated_item_id },
        });
    });
};

// 添加购物车（商详页返回时引导加购弹窗）
export const logAlertBackAddCartClick = (item_id, sku_id, add_type: 0 | 1, installment_type: -1 | 0 | 1, type) => {
    logger.sendClick({
        action: 'ADD_TO_CART',
        params: {
            // 商品id
            item_id,
            // sku_id
            sku_id,
            add_type, // 0-吊起规格页，1-加购成功,
            installment_type,
            type,
        },
    });
};

// 添加购物车（商详外显按钮）
export const logClickAddCart = (item_id, sku_id, add_type: 0 | 1, installment_type: -1 | 0 | 1) => {
    logger.sendClick({
        action: 'ADD_TO_CART',
        params: {
            // 商品id
            item_id,
            // sku_id
            sku_id,
            add_type, // 0-吊起规格页，1-加购成功,
            installment_type,
        },
    });
};
// 添加购物车(规格弹窗内按钮)
export const logClickSpecAddCart = ({ item_id, sku_id, sku_num, type = '', source = 'current', releated_item_id = '' }) => {
    logger.sendClick({
        action: 'SPEC_ADD_TO_CART',
        params: {
            // 商品id
            item_id,
            // sku_id
            sku_id,
            // 加购数量
            sku_num,
            // 加购来源, popup：加购引导弹窗
            type,
            source,
            releated_item_id,
        },
    });
};

export const logClickShare = (itemId, entranceType) => {
    logger.sendClick({
        action: 'SHARE',
        params: {
            // 商品id
            product_id: itemId,
            // 入口来源，0-站内私信分享，1-站外分享
            entrance_type: entranceType,
        },
    });
};

export const logClickContact = itemId => {
    logger.sendClick({
        action: 'PRODUCT_DETAILS_CONTACT',
        params: {
            product_id: itemId,
        },
    });
};

export const logClickGoToDetail = () => {
    logger.sendClick({
        action: 'SKIP_TO_PRODUCT_DETAILS',
    });
};

export const logShowHalfSpecPage = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'HALF_PRODUCT_SPECIFICATION',
        });
    });
};

export const logClickAddress = (source: string) => {
    logger.sendClick({
        action: 'ADDRESS',
        params: {
            source,
        },
    });
};

export const logClickSpecHalfAddCart = item_id => {
    logger.sendClick({
        action: 'ADD_TO_CART_BUTTON',
        params: {
            item_id,
        },
    });
};

export const logClickSpecHalfBuyButton = item_id => {
    logger.sendClick({
        action: 'BUY_BUTTON',
        params: {
            item_id,
        },
    });
};

// 商铺卡片曝光
export const logShowMerchantCard = ({ uid, userStatus }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'SHOP_CARD',
            params: {
                uid,
                userStatus,
            },
        });
    });
};

// 商铺卡片点击
export const logClickMerchantCard = ({ uid, userStatus }) => {
    logger.sendClick({
        action: 'SHOP_CARD',
        params: {
            uid,
            userStatus,
        },
    });
};

// 推荐卡片曝光
export const logShowNewRecoItems = ({ product_id, item_id, llsid, exptag, exp_tag }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'SHOP_RECOMMEND_CARD',
            params: { product_id, item_id, llsid, exptag, media_source: 5, exp_tag },
        });
    });
};

// 推荐卡片曝光
export const logShowRecoItems = product_id => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'SHOP_RECOMMEND_CARD',
            params: { product_id },
        });
    });
};

// 推荐卡片点击
export const logClickRecoItems = ({ product_id, price, llsid, exp_tag }) => {
    logger.sendClick({
        action: 'SHOP_RECOMMEND_CARD',
        params: {
            product_id,
            price,
            media_source: 5,
            llsid,
            exp_tag,
        },
    });
};

export const logShowUseCoupon = ({ product_id, coupon_amt, coupon_id, coupon_type }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_CARD',
            params: {
                product_id, // 商品id
                coupon_amt, // 外显优惠券金额
                coupon_id, // 优惠券批次id
                coupon_type, // 优惠券类型
            },
        });
    });
};

// 优惠券可用商品列表页点击
export const logClickUseCoupon = ({ product_id, coupon_amt, coupon_id, coupon_type }) => {
    logger.sendClick({
        action: 'PRODUCT_CARD',
        params: {
            product_id, // 商品id
            coupon_amt, // 外显优惠券金额
            coupon_id, // 优惠券批次id
            coupon_type, // 优惠券类型
        },
    });
};

// 优惠券可用商品列表页tc点击
export const logClickUseTc = () => {
    logger.sendClick({
        action: 'T_AND_C',
    });
};

// 自建优惠券列表的优惠券曝光
export const logShowKwaiShopCoupon = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'COUPON_CARD',
            params: {
                coupon_amt, // 外显优惠券金额
                coupon_id, // 优惠券批次id
                coupon_type, // 优惠券类型
                coupon_status, // 优惠券状态
            },
        });
    });
};

// 自建优惠券列表的优惠券点击
export const logClickKwaiShopCoupon = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
    logger.sendClick({
        action: 'COUPON_CARD',
        params: {
            coupon_amt, // 外显优惠券金额
            coupon_id, // 优惠券批次id
            coupon_type, // 优惠券类型
            coupon_status, // 优惠券状态
        },
    });
};

// 商详页优惠券详情卡片曝光
export const logShowDetailCouponCard = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'COUPON_DETAIL_CARD',
            params: {
                coupon_amt, // 外显优惠券金额
                coupon_id, // 优惠券批次id
                coupon_type, // 优惠券类型
                coupon_status, // 优惠券状态
            },
        });
    });
};

// 商详页优惠券详情强提醒卡片曝光
export const logShowDetailCouponStrongCard = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'COUPON_STRONG',
            params: {
                coupon_amt, // 外显优惠券金额
                coupon_id, // 优惠券批次id
                coupon_type, // 优惠券类型
                coupon_status, // 优惠券状态
            },
        });
    });
};

// 商详页-优惠券面板-曝光
export const logShowCouponPanel = () => {
    console.log('COUPON_DETAIL');
    afterPv.then(() => {
        logger.sendShow({
            action: 'COUPON_DETAIL',
        });
    });
};

// 商详页优惠券详情卡片点击
export const logClickDetailCouponCard = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
    logger.sendClick({
        action: 'COUPON_DETAIL_CARD',
        params: {
            coupon_amt, // 外显优惠券金额
            coupon_id, // 优惠券批次id
            coupon_type, // 优惠券类型
            coupon_status, // 优惠券状态
        },
    });
};

// 商详页优惠券详情卡片点击
export const logClickDetailCouponStrongCard = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
    logger.sendClick({
        action: 'COUPON_STRONG',
        params: {
            coupon_amt, // 外显优惠券金额
            coupon_id, // 优惠券批次id
            coupon_type, // 优惠券类型
            coupon_status, // 优惠券状态
        },
    });
};

// 只有是“更多”按钮的点击才会上报
export const logClickMore = () => {
    logger.sendClick({
        action: 'MORE_COUPON',
        // debuggerName: '订单确认页-优惠券选择页-展开更多优惠券',
    });
};

// 提单页优惠券详情卡片曝光
// export const logShowConfirmOrderCouponCard = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
// logger.sendShow({
//         action: 'COUPON_DETAIL_CARD',
//         params: {
//             coupon_amt, // 外显优惠券金额
//             coupon_id, // 优惠券批次id
//             coupon_type, // 优惠券类型
//             coupon_status, // 优惠券状态
//         },
//     });
// };

// 提单页优惠券详情卡片点击
// export const logClickConfirmOrderCouponCard = ({ coupon_amt, coupon_id, coupon_type, coupon_status }) => {
//     logger.sendClick({
//         action: 'COUPON_DETAIL_CARD',
//         params: {
//             coupon_amt, // 外显优惠券金额
//             coupon_id, // 优惠券批次id
//             coupon_type, // 优惠券类型
//             coupon_status, // 优惠券状态
//         },
//     });
// };

// 订单详情页优惠券过期确认弹窗曝光
export const logShowDetailOrderCouponDialog = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'COUPON_EXPIRED_POPUP',
        });
    });
};

// 订单详情页优惠券过期确认弹窗点击
export const logClickDetailOrderCouponDialog = ({ btn_name }) => {
    logger.sendClick({
        action: 'COUPON_EXPIRED_POPUP',
        params: {
            btn_name, // 按钮名称 yes no
        },
    });
};

export const logShowMessage = (itemId: any, toastType: any) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_SPEC_TOAST',
            params: { product_id: itemId, entrance_type: '', toast_type: toastType }, // toast_type:提示种类，0-选择规格，1-不可删减，2-库存不足
        });
    });
};

export const logClickBuyNowSpec = (itemId, specInfo, skuId, coupon_id = '', is_with_coupon = 0) => {
    // type:跳转类型，0-唤起规格页，1-跳转确认订单页
    // spec_info:商品规格
    // produtc_id:商品item_id
    // sku_id:skuid
    logger.sendClick({
        action: 'SPEC_CONFIRM',
        params: { type: 1, product_id: itemId, spec_info: specInfo, sku_id: skuId, coupon_id, is_with_coupon },
    });
};

export const logClickSpecImgContiner = itemId => {
    logger.sendClick({
        action: 'SPEC_IMAGE',
        params: { product_id: itemId, entrance_type: '' },
    });
};

export const logClickImgFullSwitch = index => {
    logger.sendClick({
        action: 'PRODUCT_IMAGE_FULL_SWITCH',
        params: { image_type: index > 0 ? 0 : 1 },
    });
};

export const logClickSelectNumber = button_type => {
    logger.sendClick({
        action: 'HALF_PRODUCT_SPECIFICATION_NUM',
        params: {
            button_type,
        },
    });
};

// 多次点选只上报一次
export const logClickSelectSpec = debounce(() => {
    logger.sendClick({
        action: 'HALF_PRODUCT_SPECIFICATION_SPEC',
    });
}, 2000);

export const logShowLogitics = dayCount => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'LOGISTICS_EFFECTIVE_MODE',
            params: {
                day_num: dayCount,
            },
        });
    });
};

export const logShowInstallment = (type = 0) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'INSTALLMENT_PAYMENT',
            params: {
                show_type: type,
            },
        });
    });
};

export const logShowReturnGuarantee = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'RETURN_CHANGE_PRODDUCT_SAEGUARD',
            params: {},
        });
    });
};

export const logClickReturnGuarantee = () => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'RETURN_CHANGE_PRODDUCT_SAEGUARD',
            params: {},
        });
    });
};

export const logClickServiceGuarantee = () => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'REST_ASSURED_PURCHASE_BAR',
            params: {},
        });
    });
};

export const logShowServiceGuarantee = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'REST_ASSURED_PURCHASE_BAR',
            params: {},
        });
    });
};

// 商详页单规格透出数量选择按钮的曝光埋点
export const logShowBuyCountButton = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PLUS_MINUS_BUTTON',
            params: {},
        });
    });
};

// 商详页单规格透出数量选择按钮的点击埋点
export const logClickBuyCountButton = ({ type }) => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'PLUS_MINUS_BUTTON',
            params: {
                plus_minus: type,
            },
        });
    });
};

// 商详页卡片曝光
export const logShowDetailCard = (retrievalInfo, media_id = '') => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'PRODUCT_CARD',
            params: {
                item_type: retrievalInfo?.itemType,
                exptag: retrievalInfo?.expTag,
                llsid: retrievalInfo?.llsid,
                provider_source: retrievalInfo?.providerSource,
                media_source: '18',
                media_id,
            },
        });
    });
};

const defaultCommentText = [
    'Os usuários não preencheram o conteúdo da avaliação.',
    'Você não fez avaliação após o limite de tempo. O sistema dá uma classificação de 5 estrelas por padrão',
    'O usuário acha que o produto é muito bom e vale a pena comprar',
];
const getCommentType = (comment: Comment) => {
    if (comment?.defaultComment) {
        return 'default';
    }
    if (comment?.videoList?.length) {
        return 'video';
    }
    if (!comment?.imageUrl?.length && comment?.detail === defaultCommentText[0]) {
        return 'only_star';
    }
    if (comment?.imageUrl?.length && comment?.detail === defaultCommentText[0]) {
        return 'graphic';
    }
    if (!comment?.imageUrl?.length && !defaultCommentText?.includes(comment?.detail)) {
        return 'text';
    }
    if (comment?.imageUrl?.length && !defaultCommentText?.includes(comment?.detail)) {
        return 'graphic_and_text';
    }
    return '';
};

export const logShowCommentLine = (logCommentsInfo: Comment[]) => {
    let reviews_id = '';
    let reviews_star = '';
    let reviews_type = '';
    let photo_id = '';
    if (logCommentsInfo?.length) {
        logCommentsInfo.forEach((comment: Comment) => {
            reviews_id = reviews_id + comment.commentId + ',';
            reviews_star = reviews_star + comment.productScore + ',';
            reviews_type = reviews_type + getCommentType(comment) + ',';
            photo_id = photo_id + (comment.videoList?.[0]?.videoId || '') + ',';
        });
    }
    afterPv.then(() => {
        logger.sendShow({
            action: 'CUSTOMER_REVIEWS',
            params: {
                reviews_id: reviews_id.replace(/,\s*$/, ''),
                reviews_star: reviews_star.replace(/,\s*$/, ''),
                reviews_type: reviews_type.replace(/,\s*$/, ''),
                photo_id: photo_id.replace(/,\s*$/, ''),
            },
        });
    });
};

export const logClickCommentLineNew = ({ click_type = 'default', photo_id = '' }) => {
    logger.sendClick({
        action: 'CUSTOMER_REVIEWS',
        params: {
            click_type,
            photo_id,
        },
    });
};

export const logClickCommentLine = () => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'CUSTOMER_REVIEWS',
        });
    });
};

export const logShowGalleryLine = (num: number) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'BUYER_GALLERY_FLOOR',
            params: {
                reviews_num: num,
            },
        });
    });
};

export const logClickGalleryLine = (num: number) => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'BUYER_GALLERY_FLOOR',
            params: {
                reviews_num: num,
            },
        });
    });
};

export const logShowCommentImage = (stars: (number | string)[]) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'GLOWING_REVIEWS_PICTURE',
            params: {
                customer_reviews_type: stars,
            },
        });
    });
};

export const logClickCommentImage = () => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'GLOWING_REVIEWS_PICTURE',
        });
    });
};

export const logClickCommentImageLine = (stars: (number | string)[]) => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'GLOWING_REVIEWS_CONTENT',
            params: {
                customer_reviews_type: stars,
            },
        });
    });
};

export const logClickCommentImageButton = (stars: (number | string)[]) => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'CHECK_ALL_RATES',
            params: {
                customer_reviews_type: stars,
            },
        });
    });
};

export const logClickNavbarBanner = (type: string) => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'GLOWING_REVIEWS_SORT',
            params: {
                type,
            },
        });
    });
};

export const logShowViewMoreButton = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'VIEW_MORE_BUTTON',
        });
    });
};

export const logClickViewMoreButton = () => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'VIEW_MORE_BUTTON',
        });
    });
};

export const logShowLogisticsCarrier = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'LOGISTICS_CARRIER_SHOW',
        });
    });
};

export const logClickAssuredPurchaseBar = () => {
    afterPv.then(() => {
        logger.sendClick({
            action: 'REST_ASSURED_PURCHASE_BIG_BAR',
        });
    });
};

export const logShowAssuredPurchaseBar = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'REST_ASSURED_PURCHASE_BIG_BAR',
            params: {
                exposure_state: 'initial',
            },
        });
    });
};

export const logShowAssuredPurchaseBarLast = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'REST_ASSURED_PURCHASE_BIG_BAR',
            params: {
                exposure_state: 'end',
            },
        });
    });
};
